import React, {useEffect, useState} from 'react';
import DatePicker from "react-datepicker";
import TextInput from "@/Shared/TextInput";
import {format} from "date-fns";

class CustomTimeInput extends React.Component {

  render() {
    return (
      <TextInput
        type="text"
        placeholder={format(new Date(), 'y-MM-dd')}
        value={this.props.value}
        label={this.props.label}
        onClick={this.props.onClick}
        errors={this.props.errors}
        readOnly
        className={'w-full'}
      />
    );
  }
}


const DateInput = ({date, setDate, valueName, label, errors}) => {
const [isHide, setIsHide] = useState(!date || date === '0000-00-00 00:00:00');
const [time, setTime] = useState(null);

const handleCheck = () => {
  setIsHide(!isHide);
  if (!isHide) {
    setDate(valueName, null);
  } else {
    setDate(valueName, new Date());
  }
}

const handleTimeChange = (date) => {
  setTime(date);
  setDate(valueName, date.toISOString());
}

useEffect(() => {
  if (!date || date === '0000-00-00 00:00:00') {
    setTime(new Date());
    setIsHide(true);
  } else {
    setTime(new Date(date));
    setIsHide(false);
  }
}, [])


  return (
    <div className={'w-full'}>
      <div className={'w-full flex items-center lg:w-1/2 pb-8 pr-6'}>
        {(!isHide) ?
          <DatePicker
            selected={time}
            onChange={handleTimeChange}
            dateFormat="MM/dd/yyyy h:mm aa"
            customInput={<CustomTimeInput label={label} errors={errors}/>}
            timeInputLabel="Time:"
            showTimeInput
          /> :
          <TextInput
            type="text"
            readOnly={true}
            label={label}
            className={'w-full'}
          />
        }

        <div className={'lg:w-1/2 ml-2.5 mt-2'}>
          <label className={'flex items-center'}>
            Empty value:
            <input className={'ml-1 mt-0.5'} type="checkbox" onChange={handleCheck} defaultChecked={isHide} value={isHide}/>
          </label>
        </div>
      </div>
    </div>


  );
};

export default DateInput;
